import React, { useState, useEffect } from "react";
import { Modal } from 'react-responsive-modal';
import LazyLoad from 'react-lazyload';
import { useStateValue } from "../../store/state";
import { HOMEPAGECONTENTPUBLIC } from "../../store/Home/Actions";

function DailyPopup() {
  const [{ HOME_POPUP_CONTENTS }, dispatch] = useStateValue();
  const [dailyPopupOpen, setDailyPopupOpen] = useState(false);
  const [dailyPopupData, setDailyPopupData] = useState(null);

  useEffect(() => {
    // Fetch homepage content if not already available. This includes the popup data.
    if (!HOME_POPUP_CONTENTS) {
      const userId = localStorage.getItem('userid');
      const storeId = localStorage.getItem('storeid');
      // The popup is user-specific, so only fetch if there is a user.
      if (userId) {
        HOMEPAGECONTENTPUBLIC(dispatch, userId, storeId);
      }
    }
  }, [dispatch, HOME_POPUP_CONTENTS]);

  useEffect(() => {
    const userId = localStorage.getItem('userid');

    if (!userId || !HOME_POPUP_CONTENTS) {
      return;
    }

    // The API returns the image URL directly in HOME_POPUP_CONTENTS
    const popupBanner = HOME_POPUP_CONTENTS;
    if (!popupBanner) {
      return; // No popup banner found
    }

    // --- FOR TESTING ---
    // Set this to `true` to always show the popup, bypassing the daily limit.
    // Remember to set it back to `false` for production.
    const isTesting = false;
    if (isTesting) {
      setDailyPopupData(popupBanner);
      setDailyPopupOpen(true);
      return;
    }
    // --- END TESTING ---

    const today = new Date().toISOString().split('T')[0];
    const popupTrackerKey = `daily_popup_tracker_${userId}`;
    let tracker;

    try {
      tracker = JSON.parse(localStorage.getItem(popupTrackerKey));
    } catch (e) {
      tracker = null;
    }

    const twoHoursInMs = 2 * 60 * 60 * 1000;
    const now = Date.now();

    if (!tracker || tracker.date !== today) {
      // First time today or first time ever. Show popup.
      setDailyPopupData(popupBanner);
      setDailyPopupOpen(true);
      const newTracker = { date: today, firstShown: now, shownSecond: false };
      localStorage.setItem(popupTrackerKey, JSON.stringify(newTracker));
    } else if (!tracker.shownSecond && (now - tracker.firstShown >= twoHoursInMs)) {
      // It's been 2 hours since the first popup, and the second one hasn't been shown.
      setDailyPopupData(popupBanner);
      setDailyPopupOpen(true);
      const updatedTracker = { ...tracker, shownSecond: true };
      localStorage.setItem(popupTrackerKey, JSON.stringify(updatedTracker));
    }
  }, [HOME_POPUP_CONTENTS]);

  if (!dailyPopupOpen || !dailyPopupData) return null;

  return (
    <Modal open={dailyPopupOpen}
      onClose={() => setDailyPopupOpen(false)}
      closeOnOverlayClick={false}
      classNames={{
        overlay: 'customOverlay',
        modal: 'customModal__promo',
      }}
      center>
      <div className="promo__banner">
        <LazyLoad>
          <img
            src={`${dailyPopupData}`}
            alt="Popup"
            style={{ maxWidth: '100%', cursor: 'default' }}
          />
        </LazyLoad>
        <svg onClick={() => setDailyPopupOpen(false)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16" >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
    </Modal>
  );
}

export default DailyPopup;